import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { searchPedidos } from '../../../../../actions';
import { connect } from 'react-redux';
import moment from 'moment';
import { Panel } from 'react-bootstrap';
import Alert from '../../../../../components/Alert';

const IND_FIFO = 'S';
const IND_SELECCIONADO = 'S';
const vacio='';
const nroPag=1;
const cantidadxPag=10000;

const PedidosPill = (props) => {
  if (!props.pedidos.length) return null;
  return props.pedidos.map(({ numPedidoVeh }) => (
    <li className='pill pill-cyan pillSelct-pills-item' key={numPedidoVeh}>
      {numPedidoVeh}
      <button type='button' className='pillSelct-delete' onClick={() => props.unselectPedido(numPedidoVeh)}>
        <i className='icon ion-close pill-close' />
      </button>
    </li>
  ));
};

const Cantidad = (props) => {
  if (!props.cantidad) return null;
  return (
    <div className='pillSelct'>
      <p className='pillSelct-label labelInfo'>
        <span>Has seleccionado</span>
        <span> {props.cantidad}/{props.canVeh}</span>
        <span>vehículos</span>
      </p>
    </div>
  );
};



const PedidosTabla = (props) => {
  if(props.pedidos===null || props.pedidos.listadoPedidosAsignados===null){
      return (
        <tr><td colSpan={8}>No hay resultados</td></tr>
      );
  }else if (!props.pedidos || !props.pedidos.listadoPedidosAsignados.length) {
        return (
          <tr><td colSpan={8}>No hay resultados</td></tr>
        );
  }
  const { pedidos, pedidosSeleccionados } = props;

  return pedidos.listadoPedidosAsignados.map((pedido,i) => (
    <tbody>
        <tr key={pedido.numPedidoVeh} style={{ background: pedido.indFifo==='S' ? 'lightgray' : 'white'}} >
          <td>
            <div className='checkbox checkbox-inline'>
              <label htmlFor={pedido.numPedidoVeh}>
                <input type='checkbox' checked={pedidosSeleccionados.filter(({ numPedidoVeh }) => numPedidoVeh === pedido.numPedidoVeh).length} />
                <div className='checkbox-skin' onClick={() => props.selectPedido(pedido,props.cantidadVehiculo)} />
              </label>
            </div>
          </td>
          <td>{pedido.numPedidoVeh}</td>
          <td>{pedido.numChasis}</td>
          <td>{pedido.anoFabricacionVeh}</td>
          <td>{pedido.desColor}</td>
          <td>{pedido.desSituPedido}</td>
          <td>{pedido.desUbicaPedidoVeh}</td>
          <td>{pedido.fechaAduana!==null?moment(pedido.fechaAduana).format('DD/MM/YYYY'):null}</td>
          <td onClick={() => props.toggleRow(i)} className='ion-chevron-down ml-3 c-cyan  open'  />
        </tr>
        <tr className='table-extra'>
          <td colSpan='13'>
          <Panel collapsible expanded={props.functionDespliegue(i)} style={{ borderColor: 'transparent', boxShadow: '0 0 0 white', margin: '0', backgroundColor: 'inherit' }}>
              <div className='collapse in'>
                <div className='table-extra-wrap'>
                  <ul className='row'>
                        <li className='col-md-2'>
                          <p className='labelInfo'>Estado</p>
                          <p>{pedido.estadoPedido}</p>
                        </li>
                        <li className='col-md-2'>
                          <p className='labelInfo'>Baumuster</p>
                          <p>{pedido.descBaumuster}</p>
                        </li>
                        <li className='col-md-2'>
                          <p className='labelInfo'>Placa</p>
                          <p>{pedido.numPlacaVeh}</p>
                        </li>
                        <li className='col-md-2'>
                          <p className='labelInfo'>SKU</p>
                          <p>{pedido.skuSap}</p>
                        </li>
                        <li className='col-md-2'>
                          <p className='labelInfo'>Compañia</p>
                          <p>{pedido.desCia}</p>
                        </li>
                    </ul>
                    </div>
                </div>
             </Panel>
            </td>
        </tr>
    </tbody>
  ));
};

class FirstStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pedidosSeleccionados:[],
      pedidoInput: this.props.pedidoInput,
      pedidosSeleccionadosReservados : [],
      cantidadxPag:10,
      cantidadTotalPag:0
    };
  }

  componentDidMount() {

    if(this.props.pedidosSeleccionadosOld.length>0){
      this.setState({
        pedidosSeleccionados:this.props.pedidosSeleccionadosOld
      })
    }else{
        this.fnPedidosSeleccionado();
    }

  }





  fnPedidosSeleccionado = () => {

    this.props.waitForService();
    const { skuSap, codFamiliaVeh, numProfVeh ,numFichaVtaVeh } = this.props.proforma;


    let pedidosSeleccionados=[];
    this.props.searchPedidos(vacio, vacio, vacio, vacio, vacio, skuSap, codFamiliaVeh, numFichaVtaVeh, numProfVeh, nroPag, cantidadxPag)
    .then(result => {
      pedidosSeleccionados=result.payload.data.listadoPedidosAsignados
                          .filter(entry => entry.indSeleccionado === IND_SELECCIONADO);

      this.setState({
        pedidosSeleccionados:pedidosSeleccionados,
        cantidadxPag:pedidosSeleccionados.length<=10?10:pedidosSeleccionados.length,
        pedidosSeleccionadosReservados:pedidosSeleccionados,
        cantidadTotalPag:result.payload.data.listadoPedidosAsignados.length
      })
      this.props.searchPedido(vacio,1,pedidosSeleccionados.length<=10?10:pedidosSeleccionados.length);


    });
  }


  onChangeValue = e => this.setState({ [e.target.name]: e.target.value })

  unselectPedido = (numpedido) => {

    this.setState({
      pedidosSeleccionados: this.state.pedidosSeleccionados
                              .filter(pedido => pedido.numPedidoVeh !== numpedido),
    });
  }

  selectPedido = (pedido, cantidadVehiculo) => {

    console.log('pedido', pedido);
    if(pedido.estadoPedido!=='LINE UP'){
      //I-87820
      if (pedido.codEstadoPedido === 'T') {
        this.props.openAlertModal({estadoTrama:'0',mensaje:'No puede seleccionar un pedido con estado "En Tránsito", cambie el estado primero.'})
      } else {
      //F-87820
        const { pedidosSeleccionados } = this.state;
        if((this.props.pedidosConCheck.length + pedidosSeleccionados.length + this.props.numPedidosProforma.length < cantidadVehiculo) ||
        pedidosSeleccionados.filter(({ numPedidoVeh }) => numPedidoVeh === pedido.numPedidoVeh).length){


          if (pedidosSeleccionados.filter(({ numPedidoVeh }) =>
              numPedidoVeh === pedido.numPedidoVeh).length) {
            this.setState({
              pedidosSeleccionados: pedidosSeleccionados
                                      .filter(({ numPedidoVeh }) => numPedidoVeh !== pedido.numPedidoVeh),
            });

            this.props.fnPedidosSeleccionadosOld(pedidosSeleccionados
                                    .filter(({ numPedidoVeh }) => numPedidoVeh !== pedido.numPedidoVeh));

          } else if (pedidosSeleccionados.length < parseInt(this.props.proforma.canVeh, 10)) {

           if(this.state.pedidosSeleccionadosReservados.filter(entry => entry.numPedidoVeh!==pedido.numPedidoVeh).length){
                  this.props.openAlertModal({estadoTrama:'0',mensaje:'Selecccionó un vehiculo que no cumple con FIFO'})
           }
            this.setState({ pedidosSeleccionados: [...pedidosSeleccionados, pedido] });
            this.props.fnPedidosSeleccionadosOld([...pedidosSeleccionados, pedido] );
          }

        }else{
          this.props.openAlertModal({estadoTrama:'0',mensaje:'No se puede preasignar mas pedidos debido a que supero la Cantidad de Unidades, Desasigne pedidos para poder seleccionar uno.'})
        }
      } //REQ.87820
    }else{
      this.props.openAlertModal({estadoTrama:'0',mensaje:'No se puede preasignar unidades en Line UP .'})

    }

  }

  handlePageClick = ({ selected }) => {
    this.props.searchPedido('',selected + 1,this.state.cantidadxPag);
  }

  functionDespliegue = (index) => {
    const isExpanded = index === this.state.rowSelected;
    return isExpanded;
  }

  toggleRow = (index) =>{
    if (index === this.state.rowSelected) {
      this.setState({ rowSelected: '' });
    } else {
      this.setState({ rowSelected: index });
    }
  }

  render() {
    const { proforma, pedidos } = this.props;
    const { pedidosSeleccionados, pedidoInput } = this.state;

    return (
      <div className='fdvAsig-slides-item simpleSlide active'>
        <div className='card card-plain mb-4 mt-4'>
          <div className='row'>
            <div className='col-md-5ths'>
              <p className='labelInfo'>Familia</p>
              <p>{proforma.desFamiliaVeh}</p>
            </div>
            <div className='col-md-5ths'>
              <p className='labelInfo'>Marca</p>
              <p>{proforma.nomMarca}</p>
            </div>
            <div className='col-md-5ths'>
              <p className='labelInfo'>Modelo</p>
              <p>{proforma.desBaumuster}</p>
            </div>
            <div className='col-md-5ths'>
              <p className='labelInfo'>Cant. Unid.</p>
              <p>{proforma.canVeh}</p>
            </div>
            <div className='col-md-5ths'>
              <p className='labelInfo'>Carrocero</p>
              <p>{proforma.proveedorCarrocero}</p>
            </div>
          </div>
        </div>
        <div className='tableSearch'>
          <h4 className='mt-4 mb-2 labelInfo'>Buscar un pedido:</h4>
          <div className='row'>
            <div className='col-md-6 mb-3 mt-2'>
              <div className='input-group'>
                <input
                  className='search-query form-control'
                  type='text'
                  name='pedidoInput'
                  value={pedidoInput}
                  onChange={this.onChangeValue}
                  placeholder='Digita uno o más pedidos'
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      this.props.searchPedido(pedidoInput,1,this.state.cantidadxPag);
                    }
                  }}
                />
                <span className='input-group-btn'>
                  <button className='btn btn-default' type='button' onClick={() => this.props.searchPedido(pedidoInput,1,this.state.cantidadxPag)}>
                    <i className='ion-android-arrow-forward' />
                  </button>
                </span>
              </div>
            </div>
          </div>
          <Cantidad cantidad={pedidosSeleccionados.length} canVeh={proforma.canVeh} />
          <ul className='pillSelct-pills'>
            <PedidosPill pedidos={pedidosSeleccionados} unselectPedido={this.unselectPedido} />
          </ul>
          <div className='hidden-xs'>
            <div className='tableWrapper'>
              <table className='table table-hover'>
                <thead className='table-head'>
                  <tr>
                    <th />
                    <th>N° Pedido</th>
                    <th>N° Chasis</th>
                    <th>Año Fabricación</th>
                    <th>Color</th>
                    <th>Situación</th>
                    <th>Ubicación</th>
                    <th>Fec. In. Aduanas</th>

                    <th/>
                  </tr>
                </thead>

                  <PedidosTabla
                    pedidos={pedidos}
                    selectPedido={this.selectPedido}
                    pedidosSeleccionados={pedidosSeleccionados}
                    cantidadVehiculo={proforma.canVeh}
                    functionDespliegue={this.functionDespliegue}
                    toggleRow={this.toggleRow}
                  />

              </table>
            </div>
          </div>
        </div>

        <div className={this.state.cantidadTotalPag > 10 ? 'paginationWrapper' : 'hidden'}>
          <div className='row'>
            <div className='col-sm-6 pull-right'>
              <ReactPaginate
                pageCount={Math.floor(this.state.cantidadTotalPag/10)+1}
                onPageChange={this.handlePageClick}
                previousLabel='<<'
                nextLabel='>>'
                containerClassName='pagination pull-right'
                pageClassName='pagination-item'
                activeClassName='pagination-item--active'
                pageLinkClassName='btn-clean pagination-item-btn'
                breakClassName='break pagination-item'
              />
            </div>
          </div>
        </div>

        <div className='modal-actions'>
          <button
            className='btn btn-primary pull-right'
            onClick={() => this.props.nextStep('FirstStep', this.state)}
            disabled={!pedidosSeleccionados.length}
          >
            Siguiente
          </button>
        </div>

        {
          this.props.pedidosBuscar && this.props.pedidosBuscar.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar pedidosBuscar</p>
            </Alert> : null
        }


      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    pedidos: state.pedidosBuscar,
  };
}

export default connect(mapStateToProps,
  { searchPedidos })(FirstStep);



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Proformas/AsociarPedidos/FirstStep.js